<template>
    <p-search-screen
        title="Course Request Types"
        api-destination="courserequestbookstatus"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        add-bulk-is-active-toggle
        :use-bootstrap-selection="false"
        edit-key="courseRequestBookStatusId"
        add-new-button />
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'CourseRequestBookStatusFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: true,
                searchBy: 'All'
            },
            filterBy: ['All', 'Name', 'Abbreviation'],
            fields: [
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'abbreviation',
                    sortable: true
                },
                {
                    key: 'isSystem',
                    label: 'System',
                    sortable: true,
                    formatter: value => {
                        return value ? 'Yes' : 'No';
                    }
                },
                {
                    key: 'isActive',
                    sortable: true,
                    disabled: true
                }
            ]
        };
    }
};
</script>
